export type LaborStagesLoadStatus = "loading" | "ready" | "failed";

export type BirthObservationsLoadStatus = "loading" | "ready" | "failed";

/** Flowsheet edits are allowed only when labor stages and birth observations have loaded. */
export function isLaborAmendFlowsheetEditingEnabled({
  laborStagesLoadStatus,
  birthObservationsLoadStatus,
}: {
  laborStagesLoadStatus: LaborStagesLoadStatus;
  birthObservationsLoadStatus: BirthObservationsLoadStatus;
}): boolean {
  return laborStagesLoadStatus === "ready" && birthObservationsLoadStatus === "ready";
}

/**
 * Sign & Lock is enabled when encounter questionnaire data is loaded and either labor stages
 * are ready or there are no queued flowsheet previews that require stage resolution.
 */
export function isLaborAmendSignAndLockReady({
  isEncounterDataReady,
  laborStagesLoadStatus,
  birthObservationsLoadStatus,
  hasLocalAmendPreviews,
}: {
  isEncounterDataReady: boolean;
  laborStagesLoadStatus: LaborStagesLoadStatus;
  birthObservationsLoadStatus: BirthObservationsLoadStatus;
  hasLocalAmendPreviews: boolean;
}): boolean {
  if (!isEncounterDataReady) {
    return false;
  }

  if (birthObservationsLoadStatus === "loading" || laborStagesLoadStatus === "loading") {
    return false;
  }

  if (!hasLocalAmendPreviews) {
    return true;
  }

  return laborStagesLoadStatus === "ready" && birthObservationsLoadStatus === "ready";
}
